import React from "react";
import ConversationPanel from "./ConversationPanel";

/**
 * RolePlayView — full-screen role-play session, shown in place of TopicDetail.
 * When freeChat=true the panel opens in free-form conversation mode (no scenario).
 */
export default function RolePlayView({ topic, isAdmin, onExit, freeChat = false, onConvertedToTopic, onRolePlayCompleted }) {
  // For free chat, pass a minimal topic-like object with no scenario turns
  const panelTopic = freeChat
    ? { id: null, name: "Free Chat", description: "", scenario_turns: [], words: [], known_word_ids: [] }
    : topic;

  return (
    <div className="dark-scope flex flex-col h-full min-h-0" style={{ background: "var(--ink)" }}>
      {/* Top nav — Exit + session title */}
      <div className="shrink-0 flex items-center gap-3 px-4 py-3" style={{ borderBottom: "1px solid var(--panel-line)" }}>
        <button
          type="button"
          onClick={onExit}
          className="flex items-center gap-1 text-sm transition-colors"
          style={{ color: "var(--parchment-dim)" }}
          onMouseEnter={(e) => (e.currentTarget.style.color = "var(--parchment)")}
          onMouseLeave={(e) => (e.currentTarget.style.color = "var(--parchment-dim)")}
        >
          <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
          </svg>
          Exit
        </button>
        <div className="h-5 w-px" style={{ background: "var(--panel-line)" }} />
        <div className="flex items-center gap-2 min-w-0">
          <span className="text-base leading-none" aria-hidden="true">💬</span>
          <span className="text-sm font-display font-semibold truncate" style={{ color: "var(--gold-bright)" }}>
            {freeChat ? "Free Chat" : "Role Play"}
          </span>
          {!freeChat && topic?.name && (
            <>
              <span style={{ color: "var(--parchment-dim)" }}>—</span>
              <span className="text-sm truncate" style={{ color: "var(--parchment-dim)" }}>{topic.name}</span>
            </>
          )}
        </div>
      </div>

      {/* ConversationPanel fills the remaining space */}
      <div className="flex-1 min-h-0 p-4">
        <ConversationPanel topic={panelTopic} isAdmin={isAdmin} fullScreen freeChat={freeChat} onConvertedToTopic={onConvertedToTopic} onRolePlayCompleted={onRolePlayCompleted} />
      </div>
    </div>
  );
}
